import React from 'react'
import { strToDateFormat } from '../../helpers'
import { translation } from '../../i18n'
import {
  CaseCARespType,
  CaseCommonDataType,
  DestinationType,
  InsuredPersonType,
  LookupItemType,
} from '../../models'
import { RowLayout } from '../RowLayout'
import { OverviewSectionTitle } from './OverviewSectionTitle'
import { priceFormat } from '../../helpers/miscFunctions'

type cancellationOverviewParams = {
  caseCommon?: CaseCommonDataType
  caseCA?: CaseCARespType
  destinations: DestinationType[]
  sectionLabelStyles: string
} & translation

export const CancellationOverview = (params: cancellationOverviewParams) => {
  const t = params.t
  const reasons: LookupItemType[] = t(`reasons`) as any // lookup
  const relations: LookupItemType[] = t('relations') as any // lookup
  return (
    <>
      <RowLayout
        text={t('cancellationPg.reservationDate.label')}
        data={strToDateFormat(params.caseCA?.reservationDate)}
      />
      <RowLayout
        text={t('cancellationPg.destination.label')}
        data={
          params.destinations.find(
            (item: DestinationType) =>
              item.code === params?.caseCommon?.destination
          )?.name ?? params?.caseCommon?.destination
        }
      />
      <RowLayout
        text={t('cancellationPg.firstPaymentDate.label')}
        data={strToDateFormat(params.caseCA?.firstPaymentDate)}
      />
      <RowLayout
        text={t('cancellationPg.reason.label')}
        data={
          reasons.find(
            (lookupItem) => lookupItem.code === params.caseCA?.reason
          )?.name
        }
      />
      <RowLayout
        text={t('thirdPg.occurredOn.label')}
        data={strToDateFormat(params.caseCommon?.occurredOn)}
      />
      <RowLayout
        text={t('cancellationPg.affectedPerson.label')}
        // @ts-ignore
        data={
          params.caseCA?.insuredRelation === 'INS'
            ? t('cancellationPg.affectedPerson.code.INS')
            : params.caseCA?.insuredRelation === 'CAN'
              ? t('cancellationPg.affectedPerson.code.CAN')
              : relations.find(
                (lookupItem) =>
                  lookupItem.code === params.caseCA?.insuredRelation
              )?.name
        }
      />
      {params.caseCommon?.description && (
        <RowLayout
          text={t('cancellationPg.description.label')}
          data={params.caseCommon?.description}
        />
      )}
      {params.caseCA?.insuredPersons &&
        params.caseCA?.insuredPersons?.length > 0 && (
          <OverviewSectionTitle
            styles={params.sectionLabelStyles}
            titleName={t('cancellationPg.insuredPersons.title')}
          />
        )}
      {params.caseCA?.insuredPersons &&
        params.caseCA?.insuredPersons?.length > 0 &&
        params.caseCA?.insuredPersons?.map(
          (insuredPerson: InsuredPersonType, index: any) => {
            return (
              <React.Fragment key={index}>
                <RowLayout
                  text={t('firstPg.firstName.label')}
                  data={insuredPerson.firstName}
                />
                <RowLayout
                  text={t('firstPg.lastName.label')}
                  data={insuredPerson.lastName}
                />
                <RowLayout
                  text={t('firstPg.birthDate.label')}
                  data={strToDateFormat(insuredPerson.birthDate)}
                />
                <RowLayout
                  text={t('cancellationPg.relation.label')}
                  data={
                    relations.find(
                      (lookupItem) =>
                        lookupItem.code === insuredPerson.insuredRelation
                    )?.name
                  }
                />
                <OverviewSectionTitle
                  titleName={t('cancellationExpensesPg.title')}
                  styles={params.sectionLabelStyles}
                />
                <RowLayout
                  text={t('cancellationPg.priceCur.label')}
                  data={priceFormat({
                    price: params.caseCA?.priceCur,
                    currency: params.caseCA?.currency,
                  })}
                />
                <RowLayout
                  text={t('cancellationPg.refundCur.label')}
                  data={priceFormat({
                    price: params.caseCA?.refundCur,
                    currency: params.caseCA?.currency,
                  })}
                />
              </React.Fragment>
            )
          }
        )}
    </>
  )
}
